import { X } from "lucide-react";
import type { AssetType } from "@/lib/api";
import { AssetMedia } from "@/components/media/AssetMedia";
import { Dialog } from "@/components/ui/dialog";

interface Props {
  open: boolean;
  onClose: () => void;
  url: string | null;
  type: AssetType;
  posterUrl?: string | null;
  alt?: string;
}

export function MediaLightbox({ open, onClose, url, type, posterUrl, alt }: Props) {
  if (!url) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      ariaLabel={alt || "Media preview"}
      className="h-[94dvh] max-h-[94dvh] w-full max-w-[96vw] items-center justify-center rounded-none border-none bg-black/95 p-0 sm:h-[94vh] sm:max-h-[94vh] sm:rounded-none"
    >
      <div className="relative flex h-full w-full items-center justify-center">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute right-3 top-3 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-black/60 text-white backdrop-blur transition-colors hover:bg-black/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
        >
          <X className="h-4 w-4" />
        </button>
        <AssetMedia
          type={type}
          url={url}
          poster={posterUrl}
          alt={alt ?? ""}
          variant="theater"
          autoPlay
          className="bg-transparent"
        />
      </div>
    </Dialog>
  );
}
